import { createSelector } from "reselect"
import { get, capitalize } from "lodash"
import { getViewType } from "modules/portfolio-root/selectors/portfolios"
import { getDisplayTypeName } from "./items"

const getStartDate = (_, props) => get(props, "startDate")
const getEndDate = (_, props) => get(props, "endDate")
const getSecurity = (_, props) => get(props, "security", null)

export const getFileName = createSelector(
  [getSecurity, getViewType, getStartDate, getEndDate, getDisplayTypeName],
  ({ ticker }, viewType, startDate, endDate, displayTypeName) => `${ticker} ${capitalize(viewType)} ${displayTypeName} ${startDate} - ${endDate}`,
)
